import React from 'react';
import { ServiceWorkerStatus } from './ServiceWorkerStatus';
import { UpdateNotification } from './UpdateNotification';
import { ServiceWorkerDevPanel } from './ServiceWorkerDevPanel';

interface ServiceWorkerWrapperProps {
  children: React.ReactNode;
  showStatus?: boolean;
  showNotifications?: boolean;
  showDevPanel?: boolean;
}

export const ServiceWorkerWrapper: React.FC<ServiceWorkerWrapperProps> = ({
  children,
  showStatus = false, // Set to false to hide status component
  showNotifications = true, // Always show update notifications
  showDevPanel = false // Hidden by default, only show with ?debug=true
}) => {
  // Check if debug mode is enabled via URL parameter
  const isDebugMode = () => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('debug') === 'true';
    }
    return false;
  };

  const shouldShowDevPanel = showDevPanel || isDebugMode();

  return (
    <>
      {/* Main app content */}
      {children}
      
      {/* Service Worker Status (hidden by default) */}
     {showStatus && <ServiceWorkerStatus />}
      
      {/* Update Notifications (only visible when updates are available) */}
      {showNotifications && <UpdateNotification />}
      
      {/* Development Panel (only visible when ?debug=true) */}
      {shouldShowDevPanel && <ServiceWorkerDevPanel />}
      
      {/* Debug Mode Indicator */}
      {isDebugMode() && (
        <div style={{
          position: 'fixed',
          top: '10px',
          left: '10px',
          background: '#ff6b6b',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
          zIndex: 999999,
          fontFamily: 'monospace'
        }}>
          🐛 DEBUG MODE
        </div>
      )}
    </>
  );
};
